import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import swal from 'sweetalert2';
import { ManageJournalDTO } from '../Models/Journal.model';
import { SurgeonDTO, SurgeonSpecialityDTO } from '../Models/Surgeon.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import { ShiftDayTimeDTO } from '../Models/ShiftDayTime.model';


@Component({
  selector: 'app-shift-daytime',
  templateUrl: './shift-daytime.component.html',
  styleUrls: ['./shift-daytime.component.scss'],
  providers: [SrubUpService]

})
export class ShiftDaytimeComponent implements OnInit {
  loginUserId: number;

  nextButtonDisabled: boolean;
  public loading = false;
  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  showReadOnlyDiv: number;
  iValue: number;
  index: boolean;
  edit: boolean;

  shiftList: Array<ShiftDayTimeDTO>;

  //related var's of event dto
  shiftId: string;
  title: string;   //title serves as Name of journal event.
  addtocaln: boolean;

  notes: string;
  endtime: string;
  start: string;
  startdate: string;      //start sholud be in form of "YYYY-MM-DDTHH:MM:SS"
  starttime: string;

  isImpersonateMode: boolean;
  constructor(private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.index = true;
    this.invisible = 0;
    this.editvisi = 0;

    this.showEditingDiv = -1;
    this.showReadOnlyDiv = -1;
    this.addtocaln = false;
  }

  addToCaln(val) {
    this.addtocaln = val;
  }

  Timezone =
    [
      { value: '00:00:00', viewValue: '00:00' },
      { value: '00:30:00', viewValue: '00:30' },
      { value: '01:00:00', viewValue: '01:00' },
      { value: '01:30:00', viewValue: '01:30' },
      { value: '02:00:00', viewValue: '02:00' },
      { value: '02:30:00', viewValue: '02:30' },
      { value: '03:00:00', viewValue: '03:00' },
      { value: '03:30:00', viewValue: '03:30' },
      { value: '04:00:00', viewValue: '04:00' },
      { value: '04:30:00', viewValue: '04:30' },
      { value: '05:00:00', viewValue: '05:00' },
      { value: '05:30:00', viewValue: '05:30' },
      { value: '06:00:00', viewValue: '06:00' },
      { value: '06:30:00', viewValue: '06:30' },
      { value: '07:00:00', viewValue: '07:00' },
      { value: '07:30:00', viewValue: '07:30' },
      { value: '08:00:00', viewValue: '08:00' },
      { value: '08:30:00', viewValue: '08:30' },
      { value: '09:00:00', viewValue: '09:00' },
      { value: '09:30:00', viewValue: '09:30' },
      { value: '10:00:00', viewValue: '10:00' },
      { value: '10:30:00', viewValue: '10:30' },
      { value: '11:00:00', viewValue: '11:00' },
      { value: '11:30:00', viewValue: '11:30' },
      { value: '12:00:00', viewValue: '12:00' },
      { value: '12:30:00', viewValue: '12:30' },
      { value: '13:00:00', viewValue: '13:00' },
      { value: '13:30:00', viewValue: '13:30' },
      { value: '14:00:00', viewValue: '14:00' },
      { value: '14:30:00', viewValue: '14:30' },
      { value: '15:00:00', viewValue: '15:00' },
      { value: '15:30:00', viewValue: '15:30' },
      { value: '16:00:00', viewValue: '16:00' },
      { value: '16:30:00', viewValue: '16:30' },
      { value: '17:00:00', viewValue: '17:00' },
      { value: '17:30:00', viewValue: '17:30' },
      { value: '18:00:00', viewValue: '18:00' },
      { value: '18:30:00', viewValue: '18:30' },
      { value: '19:00:00', viewValue: '19:00' },
      { value: '19:30:00', viewValue: '19:30' },
      { value: '20:00:00', viewValue: '20:00' },
      { value: '21:00:00', viewValue: '21:00' },
      { value: '21:30:00', viewValue: '21:30' },
      { value: '22:00:00', viewValue: '22:00' },
      { value: '22:30:00', viewValue: '22:30' },
      { value: '23:00:00', viewValue: '23:00' },
      { value: '23:30:00', viewValue: '23:30' }
    ];

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  UserClick(btnCount) {
    this.edit = false;
    this.shiftId = "";
    this.title = "";

    this.notes = "";
    this.startdate = "";
    this.starttime = "";
    this.start = "";


    if (btnCount == 1) {
      this.edit = true;
      this.showEditingDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.showEditingDiv = -1;


    }
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  getShiftList() {
    this.loading = true;
    this.scrubUpService.GetShifts(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        this.shiftList = x['Data'];
       // console.log( this.shiftList);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  formatDateTime(dt, time) {
    var date = new Date(dt);
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]) + "T" + time;

  }

  Addshift() {
    this.start = this.formatDateTime(this.startdate, this.starttime);

    let shift: ShiftDayTimeDTO;
    shift = new ShiftDayTimeDTO();
    shift.ShiftId = "";
    shift.Title = this.title;
    shift.AddToCalendar = this.addtocaln;

    shift.Notes = this.notes;
    shift.StartDate = this.startdate;
    shift.StartTime = this.starttime;
    shift.Start = this.start;

    //manipulate the start date as per the calendar requirement

    this.loading = true;
    this.scrubUpService.AddShift(this.token, shift, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Shift Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        // this.specialityName = "";
        this.UserClick(3);
        this.getShiftList();
      }
      else if (x == "exists") {
        swal({
          title: 'Shift with this title already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    });
  }

  EditShift(index: number) {
    this.showReadOnlyDiv = -1;

    this.editvisi = 1;

    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.shiftId = this.shiftList[index].ShiftId;
      this.title = this.shiftList[index].Title;
      this.notes = this.shiftList[index].Notes;
      this.addtocaln = this.shiftList[index].AddToCalendar;
      this.startdate = this.shiftList[index].StartDate;
      this.starttime = this.shiftList[index].StartTime;
      this.start = this.shiftList[index].Start;

      this.edit = false;
    }
    else {
      this.shiftId = this.shiftList[index].ShiftId;
      this.title = this.shiftList[index].Title;
      this.notes = this.shiftList[index].Notes;
      this.addtocaln = this.shiftList[index].AddToCalendar;
      this.startdate = this.shiftList[index].StartDate;
      this.starttime = this.shiftList[index].StartTime;
      this.start = this.shiftList[index].Start;

      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  UpdateShift() {
    this.start = this.formatDateTime(this.startdate, this.starttime);

    let shift: ShiftDayTimeDTO;
    shift = new ShiftDayTimeDTO();
    shift.ShiftId = this.shiftId;
    shift.Title = this.title;
    shift.AddToCalendar = this.addtocaln;

    shift.Notes = this.notes;
    shift.StartDate = this.startdate;
    shift.StartTime = this.starttime;
    shift.Start = this.start;


    this.loading = true;

    this.scrubUpService.UpdateShift(this.token, shift, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        // this.specialityName = "";
        this.UserClick(3);
        this.getShiftList();
      }
      else {

      }
      this.loading = false;
    });

  }

  ngOnInit() {
    this.getShiftList();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/shift-daytime/shift-daytime.component.ts